import detector from 'detector';
import connectWebViewJavascriptBridge from './utils';

export default function (ua = window.navigator.userAgent || '') {
    const isApp = /SDGWB/i.test(ua);
    const appVersion = ua.split('SDGWB/')[1];
    const isAndroid = /android/i.test((detector.os || []).name);
    const isIos = /ios/i.test((detector.os || []).name);
    const isWeixin = /micromessenger/i.test((detector.browser || []).name);
    const isQQ = /qq\//i.test(ua);
    const isWeibo = /Weibo/i.test(ua);
    const isSafari = detector.browser.name === 'safari';

    if (isIos && !isApp && !isWeixin && !isQQ && !isWeibo && !isSafari) {
        connectWebViewJavascriptBridge.call({
            isAndroid: false,
            isIos: true
        }, () => {
            this.isApp = true;
        });
    }
    return {
        isApp,
        appVersion,
        isAndroid,
        isIos,
        isWeixin,
        isQQ,
        isWeibo,
        ...detector
    };
}
